import React from 'react';
import { Text, View } from 'react-native';
import { catalogProductFormStyles as styles } from './catalogProductForm.styles';
import type { CatalogProductFormFieldsProps } from './catalogProductFormFields.types';

type Props = Pick<CatalogProductFormFieldsProps, 'isDraftReady' | 'draftValidationMessage' | 'mobile'>;

export function CatalogProductFormDraftValidation({ isDraftReady, draftValidationMessage, mobile = false }: Props) {
  if (isDraftReady) {
    return null;
  }

  return (
    <View style={styles.draftNotice}>
      <Text style={styles.draftNoticeGlyph}>!</Text>
      <Text style={styles.draftNoticeText}>{draftValidationMessage}</Text>
    </View>
  );
}
